import ApiGateway from "../api.gateway";

const MotoboyService = {
  list: async function (records, page) {
    try {
      const response = await ApiGateway.get(
        `/gateway/motoboy?page=${page}&records=${records}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  filter: async function (data) {
    try {
      const response = await ApiGateway.post(
        `/gateway/motoboy/filter`, data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  calculate: async function (data) {
    try {
      const response = await ApiGateway.post(
        `/gateway/motoboy/calculate`, data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  add: async function (data) {
    try {
      const response = await ApiGateway.post(
        `/gateway/motoboy`, data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  request: async function (id) {
    try {
      const response = await ApiGateway.post(
        `/gateway/motoboy/request/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  print: async function (id) {
    try {
      const response = await ApiGateway.post(
        `/gateway/motoboy/print/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default MotoboyService;

export { MotoboyService };
